import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'prgov-dialog-comment',
  templateUrl: './dialog-comment.component.html',
  styleUrls: ['./dialog-comment.component.scss']
})
export class DialogCommentComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      createdDateTitle: string
      createdDate: string
      createdByTitle: string
      createdBy: string
      commentTitle: string
      comment: string
    }
  ) {
  }

  ngOnInit() {

  }

  ok() {
    this.dialogRef.close();
  }
}
